module.exports = __webpack_public_path__ + "img/daxiang.6a227888.png";